import styled from "styled-components";

import { colors, radii } from "shared/ui";

export const LangRow = styled.div`
    display: flex;
    justify-content: flex-end;
`;

export const Preview = styled.div`
    padding: 12px 14px;
    border-radius: ${radii.small};
    background: ${colors.segmentBg};
    color: ${colors.textSecondary};
`;

export const PreviewNames = styled.div`
    margin-top: 4px;
    color: ${colors.textPrimary};
`;
